import { render, staticRenderFns } from "./DialogFootnote.vue?vue&type=template&id=de0695a8"
import script from "./DialogFootnote.vue?vue&type=script&lang=js"
export * from "./DialogFootnote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports